import { LIST_COMPLIANCE_SEASONS_ENDPOINT } from '../../../common/config/api_endpoints';
import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../redux/actions/action_utils';
import createAmplifyAPICallEpic from '../../../redux/epics/utils';

const LIST_COMPLIANCE_SEASONS = createAPILifecycleActionTypes('LIST_COMPLIANCE_SEASONS');

export const listComplianceSeasonsActions = createAPILifecycleActions(LIST_COMPLIANCE_SEASONS.NAME);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case LIST_COMPLIANCE_SEASONS.BEGIN:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case LIST_COMPLIANCE_SEASONS.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    case LIST_COMPLIANCE_SEASONS.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        error: payload,
      };
    case LIST_COMPLIANCE_SEASONS.CLEAR:
      return initialState;
    default:
      return state;
  }
};

// clientId + country are injected automatically by the shared epic context
// (addContextToPayload), so ListComplianceSeasons needs no explicit request body.
export const listComplianceSeasonsEpic = createAmplifyAPICallEpic({
  actionType: LIST_COMPLIANCE_SEASONS.BEGIN,
  api: LIST_COMPLIANCE_SEASONS_ENDPOINT,
  successCallback: response => [listComplianceSeasonsActions.SUCCESS(response.body)],
  errorCallback: error => [listComplianceSeasonsActions.FAILURE(error)],
});
